<template>
  <basic-container>
    服务网点：<el-select v-model="nursinghomeId" placeholder="请选择服务网点">
      <el-option
        v-for="(item, index) in nursinghomeList"
        :key="index"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
    <div class="list">
      <ImportFile
        v-for="item in listData"
        :key="item.id"
        :title="item.title"
        :exportApi="item.exportApi"
        :exportParams="item.exportParams"
        :importApi="item.importApi"
        :importParams="item.importParams"
      ></ImportFile>
    </div>
  </basic-container>
</template>

<script>
import { getNursinghomeList } from '../api/public.js';
import ImportFile from './importFile';

export default {
  components: {
    ImportFile,
  },
  data() {
    return {
      nursinghomeId: '', // 养老院id
    };
  },
  computed: {
    /* 导入配置列表 */
    listData() {
      return [
        {
          id: 1,
          title: '老人列表',
          exportApi: '/api/v4ward/nursing/base/export-templateElder',
          exportParams: {
            nursingHomeId: this.nursinghomeId,
          },
          importApi: '/api/v4ward/nursing/base/importElder',
          importParams: {
            nursingHomeId: this.nursinghomeId,
          },
        },
        {
          id: 2,
          title: '智能设备管理',
          exportApi: '/api/v4ward/nursinghome/smart-device/exportTemplate',
          exportParams: {
            nursinghomeId: this.nursinghomeId,
          },
          importApi: '/api/v4ward/nursinghome/smart-device/importSmartDevice',
          importParams: {
            nursinghomeId: this.nursinghomeId,
          },
        },
        {
          id: 3,
          title: '健康记录',
          exportApi: '/api/v4ward/smart-device/health/exportTemplate',
          exportParams: {
            nursinghomeId: this.nursinghomeId,
          },
          importApi: '/api/v4ward/smart-device/health/importHealth',
          importParams: {
            nursinghomeId: this.nursinghomeId,
          },
        },
        {
          id: 4,
          title: '嘱托管理',
          exportApi: '/api/nursing/entrust/exportTemplate',
          exportParams: {
            nursinghomeId: this.nursinghomeId,
          },
          importApi: '/api/nursing/entrust/import',
          importParams: {
            nursinghomeId: this.nursinghomeId,
          },
        },
        {
          id: 5,
          title: '咨询登记',
          exportApi: '/api/nursing/registration/exportTemplate',
          exportParams: {
            nursinghomeId: this.nursinghomeId,
          },
          importApi: '/api/nursing/registration/importRegistration',
          importParams: {
            nursinghomeId: this.nursinghomeId,
          },
        },
        {
          id: 6,
          title: '服务记录',
          exportApi: '/api/v4ward/nursingservicelog/exportTemplate',
          exportParams: {
            nursinghomeId: this.nursinghomeId,
          },
          importApi: '/api/v4ward/nursingservicelog/import',
          importParams: {
            nursinghomeId: this.nursinghomeId,
          },
        },
        {
          id: 7,
          title: '适老设备管理',
          exportApi: '/api/v4ward/nursinghome/elder-device/exportTemplate',
          exportParams: {
            nursinghomeId: this.nursinghomeId,
          },
          importApi: '/api/v4ward/nursinghome/elder-device/importElderDevice',
          importParams: {
            nursinghomeId: this.nursinghomeId,
          },
        },
      ];
    },
  },
  created() {
    getNursinghomeList().then(({ data }) => {
      this.nursinghomeList = data || [];
      if (this.nursinghomeList.length > 0) {
        this.nursinghomeId = this.nursinghomeList[0].id;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.list {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.list > * {
  margin: 0 30px 40px 0;
  padding: 10px 20px;
  border: 1px solid rgb(234, 233, 233);
  border-radius: 10px;
}
</style>
